const asyncScriptLoader = (document, promise, timeout) => scriptUrl => {
	return new promise((resolve, reject) => {
		const timer = setTimeout(() => {
			reject(`Timed out loading script: ${ scriptUrl }`);
		}, timeout);

		let script = document.createElement('script');
		script.type = 'text/javascript';
		script.async = true;
		script.src = scriptUrl;
		script.addEventListener('load', () => {
			clearTimeout(timer);
			resolve();
		});

		let body = document.getElementsByTagName('body')[0];
		body.appendChild(script);
	});
};

export default asyncScriptLoader;



// WEBPACK FOOTER //
// ./src/services/asyncScriptLoader.js